import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import useStudentsReviews from '../../Hooks/useStudentsReviews';
import './StudentReviews.css'


const StudentReviews = () => {
    const [reviews] = useStudentsReviews();

    return (
        <div className='m-2'>
          <h1 className='bg-success p-2 rounded-3 text-center text-white shadow'>All reviews Of my Students</h1>

    <Row xs={1} md={2} lg={3} className="g-4">
    {
        reviews.map( review =>  <Col>
            <Card className='h-100 shadow'>
            <div className='d-flex justify-content-center align-items-left flex-column'>
            <div className='d-flex justify-content-around align-items-center my-2'> <img className='review-img' src={review.img}  alt="profile-pic"/>   <span className='ms-3 fs-5 fw-bold ratting'>{`Ratting: ${review.rating}`}</span> </div>
             <span className='ms-3 fs-3 fw-bold text-primary'>{review.name}</span>
            </div>
              <Card.Body>
               
                <Card.Text>
            <p className='text-center'>{`"${review.reviewText}"`}</p>
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>)

    }
</Row>
        </div>
       
    );
};

export default StudentReviews;

